var dropdownItemTitle = 'fx_2d2fb1e5_itgzxv1';
var dropdownItemTitleText = 'fx_2d2fb1e5_itgzxv2';

export { dropdownItemTitle, dropdownItemTitleText };
//# sourceMappingURL=itemTitle.vanilla.mjs.map
